import { z } from 'zod';

/**
 * Shop-wide scheduling rules — global for the same reason `appearance` is: one shop,
 * one answer to "is today still worth planning into."
 *
 * Starts with the end-of-day cutoff; more scheduling-behavior knobs can join this same
 * document later, the way `appearance` grew past just the font scale.
 */
export const schedulingSettings = z.object({
  /** Whether the cutoff applies at all. */
  enabled: z.boolean().default(true),
  /**
   * The shop-local hour (0–23) at and after which a re-plan stops adding new, unpinned
   * hours to today and starts from tomorrow instead — there is too little of the
   * working day left to actually use them. Already-pinned or already-completed work
   * sitting on today is untouched either way.
   */
  cutoffHour: z.number().int().min(0).max(23).default(12),
});
export type SchedulingSettings = z.infer<typeof schedulingSettings>;

export const schedulingSettingsWrite = schedulingSettings;
export type SchedulingSettingsWrite = z.infer<typeof schedulingSettingsWrite>;
